import {
    getPrimaryTextForSonoraResultsFileItems,
    getSecondaryTextForSonoraResultsFileItems,
    getTooltipStringForSonoraResultsFileItems,
    insertFileSuggestionsIntoComposeEditor,
} from './SonoraResultsUtilsForFile';
import {
    getPrimaryTextForSonoraResultsStickyNotesItems,
    getSecondaryTextForSonoraResultsStickyNotesItems,
    getTooltipStringForSonoraResultsStickyNotesItems,
    insertStickyNotesSuggestionsIntoComposeEditor,
} from '../stickyNotes/SonoraResultsUtilsForStickyNotes';
import {
    getPrimaryTextForSonoraResultsMeetingTimeItems,
    getSecondaryTextForSonoraResultsMeetingTimeItems,
    getTooltipStringForSonoraResultsMeetingTimeItems,
    insertMeetingTimeSuggestionsIntoComposeEditor,
} from '../meetingTimes/SonoraResultsUtilsForMeetingTime';
import {
    getPrimaryTextForSonoraResultsPeopleItems,
    getSecondaryTextForSonoraResultsPeopleItems,
    getTooltipStringForSonoraResultsPeopleItems,
    insertPeopleSuggestionsIntoComposeEditor,
} from '../vivaTopics/SonoraResultsUtilsForPeople';
import {
    getPrimaryTextForSonoraResultsVivaTopicEntityItems,
    getSecondaryTextForSonoraResultsVivaTopicEntityItems,
    getTooltipStringForSonoraResultsVivaTopicEntityItems,
    insertVivaTopicEntitySuggestionsIntoComposeEditor,
} from '../vivaTopics/SonoraResultsUtilsForEntity';
import {
    getPrimaryTextForSonoraResultsContactItems,
    getSecondaryTextForSonoraResultsContactItems,
    getTooltipStringForSonoraResultsContactItems,
    insertContactSuggestionsIntoComposeEditor,
    insertContactDetailsIntoComposeEditor,
} from '../contacts/SonoraResultsUtilsForContact';
import {
    SonoraDataProvider,
    SonoraEntityType,
    SonoraFile,
    SonoraFileSuggestionSourceType,
    SonoraItem,
    SonoraMeetingTimes,
    SonoraPerson,
    SonoraStickyNotes,
    SonoraTopicEntity,
    SonoraContact,
} from 'owa-editor-sonora-types';
import logSonoraDatapoint from '../../dataLogger/logSonoraDatapoint';
import { setAccepted } from '../../mutators/sonoraMutators';

export const getPrimaryTextForSonoraResultsItems = (sonoraItem: SonoraItem): string => {
    switch (sonoraItem?.type) {
        case SonoraEntityType.File:
        case SonoraEntityType.VivaTopicFile:
            return getPrimaryTextForSonoraResultsFileItems(sonoraItem as SonoraFile);
        case SonoraEntityType.VivaTopicPerson:
            return getPrimaryTextForSonoraResultsPeopleItems(sonoraItem as SonoraPerson);
        case SonoraEntityType.StickyNotes:
            return getPrimaryTextForSonoraResultsStickyNotesItems(sonoraItem as SonoraStickyNotes);
        case SonoraEntityType.MeetingTimes:
            return getPrimaryTextForSonoraResultsMeetingTimeItems(sonoraItem as SonoraMeetingTimes);
        case SonoraEntityType.VivaTopicEntity:
            return getPrimaryTextForSonoraResultsVivaTopicEntityItems(
                sonoraItem as SonoraTopicEntity
            );
        case SonoraEntityType.Contact:
            return getPrimaryTextForSonoraResultsContactItems(sonoraItem as SonoraContact);
        default:
            return '';
    }
};

export const getSecondaryTextForSonoraResultsItems = (sonoraItem: SonoraItem): string => {
    switch (sonoraItem?.type) {
        case SonoraEntityType.File:
        case SonoraEntityType.VivaTopicFile:
            return getSecondaryTextForSonoraResultsFileItems(sonoraItem as SonoraFile);
        case SonoraEntityType.VivaTopicPerson:
            return getSecondaryTextForSonoraResultsPeopleItems(sonoraItem as SonoraPerson);
        case SonoraEntityType.StickyNotes:
            return getSecondaryTextForSonoraResultsStickyNotesItems(
                sonoraItem as SonoraStickyNotes
            );
        case SonoraEntityType.MeetingTimes:
            return getSecondaryTextForSonoraResultsMeetingTimeItems(
                sonoraItem as SonoraMeetingTimes
            );
        case SonoraEntityType.VivaTopicEntity:
            return getSecondaryTextForSonoraResultsVivaTopicEntityItems(
                sonoraItem as SonoraTopicEntity
            );
        case SonoraEntityType.Contact:
            return getSecondaryTextForSonoraResultsContactItems(sonoraItem as SonoraContact);
        default:
            return '';
    }
};

export const getTooltipTextForSonoraResultsItems = (sonoraItem: SonoraItem): string => {
    switch (sonoraItem?.type) {
        case SonoraEntityType.File:
        case SonoraEntityType.VivaTopicFile:
            return getTooltipStringForSonoraResultsFileItems(sonoraItem as SonoraFile);
        case SonoraEntityType.VivaTopicPerson:
            return getTooltipStringForSonoraResultsPeopleItems(sonoraItem as SonoraPerson);
        case SonoraEntityType.StickyNotes:
            return getTooltipStringForSonoraResultsStickyNotesItems(
                sonoraItem as SonoraStickyNotes
            );
        case SonoraEntityType.MeetingTimes:
            return getTooltipStringForSonoraResultsMeetingTimeItems(
                sonoraItem as SonoraMeetingTimes
            );
        case SonoraEntityType.VivaTopicEntity:
            return getTooltipStringForSonoraResultsVivaTopicEntityItems(
                sonoraItem as SonoraTopicEntity
            );
        case SonoraEntityType.Contact:
            return getTooltipStringForSonoraResultsContactItems(sonoraItem as SonoraContact);
        default:
            return '';
    }
};

export const insertSuggestionsIntoComposeEditor = (
    sonoraItem: SonoraItem,
    dataProvider: SonoraDataProvider,
    datapointName: string
): void => {
    const {
        insertNodeCallback,
        adapter,
        editor,
        fromAddress,
        getRecipients,
        getSubject,
    } = dataProvider;
    const viewState = adapter();

    let fileSource: string | undefined = undefined;
    if (
        sonoraItem.type === SonoraEntityType.File ||
        sonoraItem.type === SonoraEntityType.VivaTopicFile
    ) {
        fileSource = SonoraFileSuggestionSourceType[(sonoraItem as SonoraFile).sourceType];
    }

    setAccepted(viewState, true);
    logSonoraDatapoint(viewState, datapointName, {
        selectedType: SonoraEntityType[sonoraItem.type],
        fileSource: fileSource,
    });

    switch (sonoraItem.type) {
        case SonoraEntityType.File:
        case SonoraEntityType.VivaTopicFile:
            insertFileSuggestionsIntoComposeEditor(
                sonoraItem as SonoraFile,
                insertNodeCallback,
                dataProvider
            );
            break;
        case SonoraEntityType.VivaTopicPerson:
            insertPeopleSuggestionsIntoComposeEditor(
                sonoraItem as SonoraPerson,
                insertNodeCallback
            );
            break;
        case SonoraEntityType.StickyNotes:
            insertStickyNotesSuggestionsIntoComposeEditor(
                sonoraItem as SonoraStickyNotes,
                insertNodeCallback
            );
            break;
        case SonoraEntityType.MeetingTimes:
            insertMeetingTimeSuggestionsIntoComposeEditor(
                sonoraItem as SonoraMeetingTimes,
                fromAddress,
                getRecipients(),
                getSubject(),
                insertNodeCallback
            );
            break;
        case SonoraEntityType.VivaTopicEntity:
            insertVivaTopicEntitySuggestionsIntoComposeEditor(
                sonoraItem as SonoraTopicEntity,
                insertNodeCallback,
                editor
            );
            break;
        case SonoraEntityType.Contact:
            insertContactSuggestionsIntoComposeEditor(
                sonoraItem as SonoraContact,
                insertNodeCallback
            );
            break;
        default:
            return;
    }
};

export const insertSuggestionDetailsIntoComposeEditor = (
    sonoraItem: SonoraItem,
    dataProvider: SonoraDataProvider,
    itemDetail: string
): void => {
    const { insertNodeCallback } = dataProvider;

    switch (sonoraItem.type) {
        case SonoraEntityType.Contact:
            insertContactDetailsIntoComposeEditor(itemDetail, insertNodeCallback);
            break;
        default:
            return;
    }
};
